export const getTextFields = (qualificationData: any) => [
    {
        id: "qualification",
        name: "name",
        label: "Name",
        type: "text",
        placeholder: "Enter Name",
        required: true,
        capitalizedFirst: true,
        value: qualificationData?.name
    },
    {
        label: "Qualification Type",
        value: qualificationData?.qualificationType,
        formField: false,
    },
    {
        label: "Status",
        value: qualificationData?.enabled === true ? 'Enabled' : 'Disabled',
        formField: false,
    },

  
];